import { selectUserId } from './selectUserId';
import { IAppState } from '../../redux';

export const selectIsLoggedIn = (state: IAppState): boolean => {
  return !!selectUserId(state);
};
